import React from "react";
import { Container, Typography } from "@mui/material";
function Restrict() {
  return (
    <Container>
      <Typography variant='h2'>Restricted Access</Typography>
      <p>
        This system is restricted to authorized users only. Unauthorized access
        or use of this system is strictly prohibited and may result in legal
        action.
      </p>
      <p style={{ lineHeight: 3 }}>
        Use of this system implies consent to monitoring, recording, and
        auditing for lawful purposes, including but not limited to ensuring
        system security and compliance with applicable laws and regulations.
        Users should have no expectation of privacy in their use of this system.
        Access to this system is governed by strict policies and is limited to
        authorized personnel. Any unauthorized attempt to access, use, or tamper
        with this system may lead to criminal and civil penalties. If you are
        not an authorized user, please disconnect immediately. If you believe
        you have received access in error, please contact the system
        administrator or your IT department. By accessing this system, you
        acknowledge and agree to the terms and conditions outlined above.
      </p>
    </Container>
  );
}

export default Restrict;
